import { ErrorModel } from '@era/app';
import { ApiClientCredential } from '@era/settings-sdk';
import { createActionGroup, props } from '@ngrx/store';
import { CategoryType } from '../shared/types';
import { ApiClientCredentialsConfiguration } from './category-api-client-setting.state';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryApiClientSettingResolverActions = createActionGroup({
  source: 'Category API client setting resolver',
  events: {
    'Category settings requested': props<{ categoryType: CategoryType; categoryId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryApiClientSettingApiActions = createActionGroup({
  source: 'Category API client setting API',
  events: {
    'Category setting loaded': props<{ configuration: ApiClientCredentialsConfiguration }>(),
    'Category setting loaded error': props<{ error: ErrorModel }>(),
    'Category setting added': props<{ configuration: ApiClientCredentialsConfiguration }>(),
    'Category setting added error': props<{ configuration: ApiClientCredentialsConfiguration; error: ErrorModel }>(),
    'Category setting updated': props<{ configuration: ApiClientCredentialsConfiguration }>(),
    'Category setting updated error': props<{ configuration: ApiClientCredentialsConfiguration; error: ErrorModel }>(),
    'Category setting deleted': props<{ configuration: ApiClientCredentialsConfiguration }>(),
    'Category setting deleted error': props<{ configuration: ApiClientCredentialsConfiguration; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const CategoryApiClientSettingViewActions = createActionGroup({
  source: 'Category API client setting view',
  events: {
    'Setting selected': props<{
      categoryType: CategoryType;
      categoryId: string;
      apiClientCredential: ApiClientCredential;
    }>(),
    'Setting deselected': props<{ categoryType: CategoryType; categoryId: string }>(),
  },
});
